import React, { useState } from "react";
import Axios from "axios";

import { ItemStateProvider } from "../../hooks";
import SellItemView from "./SellItemView";

const SellItem = ({
  selected = false,
  onOpen, item: initialItem, isFromUsersPage }) => {
  const [item, setItem] = useState(initialItem);

  const refresh = async () => {
    const response = await Axios.get(`/api/requests/${item.id}`);

    setItem({
      ...item,
      ...response.data,
    });
  };

  return (
    <ItemStateProvider item={item}>
      <SellItemView
        {...{
          item,
          refresh,
          selected,
          onOpen,
          isFromUsersPage,
        }}
      />
    </ItemStateProvider>
  );
};

export default SellItem;
